import { setHeaders } from "../utils/fetch";

function getPutObjectUrl(bucketName, objectName, user) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/minio/presignedPutObjectUrl/${bucketName}/${objectName}`,
      {
        method: "get",
        headers: setHeaders({}, user)
      }
    )
      .then(res => {
        return res.json();
      })
      .then(function(putObjectUrl) {
        resolve(putObjectUrl);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

function putObject(bucketName, objectName, file, user) {
  return new Promise((resolve, reject) => {
    getPutObjectUrl(bucketName, objectName, user).then(putObjectUrl => {
      fetch(putObjectUrl, {
        method: "PUT",
        body: file
      })
        .then(() => {
          resolve();
        })
        .catch(e => {
          window.console.error(e);
          reject();
        });
    });
  });
}

function getObjectUrl(bucketName, objectName) {
  return new Promise((resolve, reject) => {
    fetch(
      `${process.env.VUE_APP_BASE_URL.toCorrectDomain()}/api/minio/presignedGetObjectUrl/${bucketName}/${objectName}`,
      {
        method: "get"
      }
    )
      .then(res => {
        return res.json();
      })
      .then(function(url) {
        resolve(url);
      })
      .catch(e => {
        window.console.log(e);
        reject();
      });
  });
}

export { putObject, getObjectUrl };
